import { render, staticRenderFns } from "./encaissement.vue?vue&type=template&id=0946a88d&scoped=true"
import script from "./encaissement.vue?vue&type=script&lang=js"
export * from "./encaissement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0946a88d",
  null
  
)

export default component.exports